import {
  STYLE_SIZE_CONSTANTS,
  StylesClasses,
  createStyles,
} from '@utils/styles'

const styles = createStyles({
  wrapper: {
    display: 'flex',
    boxSizing: 'content-box',
    '& *': {
      boxSizing: 'border-box',
    },
    margin: 'auto',
    gap: '24px',
  },
  stickySection: {
    position: 'sticky',
    flexGrow: 1,
    minWidth: 'max-content',
    height: 'max-content',
    display: { xs: 'none', md: 'block' },
    zIndex: 1,
    top:
      STYLE_SIZE_CONSTANTS.headerHeight +
      STYLE_SIZE_CONSTANTS.overViewHeaderHeight +
      20,
  },
})

export type StylesClassNames = StylesClasses<typeof styles>
export default styles
